<template>
    <div id="Navigation" v-show="siteInfo!==null">
        <nav>
            <div class="container">
                <ul>
                    <li class="home">
                        <a class="sidebarRouter" id="sidemenus-1" @click="onlink('/home?site_no=' + $store.getters['auth/getSiteNo'])">ホーム</a>
                    </li>
                    <li class="live">
                        <a class="sidebarRouter" id="sidemenus-2" @click="onlink('/live?site_no=' + $store.getters['auth/getSiteNo'])">ライブ</a>
                    </li>
                    <li class="history">
                        <a class="sidebarRouter" id="sidemenus-3" @click="onlink('/history?site_no=' + $store.getters['auth/getSiteNo'])">履歴</a>
                    </li>
                    <li v-show="siteInfo!==null && settingCamLists" class="settings">
                        <a class="sidebarRouter" id="sidemenus-5" @click="onlink('/settings?site_no=' + $store.getters['auth/getSiteNo'])">設定</a>
                    </li>
                    <li class="help">
                        <a class="sidebarRouter" id="sidemenus-6" :href="'/help?site_no=' + this.$store.getters['auth/getSiteNo']" target="_blank">ヘルプ</a>
                    </li>
                    <li class="logout" @click="logout()">
                        <a class="sidebarRouter">ログアウト</a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
import $ from 'jquery'// eslint-disable-line
const logoutUrl = process.env.VUE_APP_LOGOUT;

export default {
    name: 'Sidebar',
    data() {
        return {
        }
    },
    props: {
        siteInfo:{
        type: Array
        },
    },
    mounted() {
        this.componentSidebarChangeLayout();
        var scrollStart = $('#Header').offset().top + 50
        var distance = 0;

        // 1024px以上の時にサイドバーをスクロールしても位置を固定させる
        $(document).scroll(function(){
            distance = $(this).scrollTop(); //スクロールした距離を取得
            if(window.matchMedia('(min-width: 1024px)').matches && window.matchMedia('(min-height: 415px)').matches) {
                if (scrollStart < distance) { //スクロール距離が『.sikaku_box』の位置を超えたら
                    $('#Navigation').css('position','fixed');
                    $('#Navigation').css('top','0px');
                    $('#mainBlock').css('margin-left','85px');
                } else { //スクロールがページ上部まで戻ったら
                    $('#Navigation').css('position','relative');
                    $('#Navigation').css('top','');
                    $('#mainBlock').css('margin-left','');
                }
            }
        });
        $(window).resize(function() {
            if (window.matchMedia('(min-width: 1024px)').matches && window.matchMedia('(min-height: 415px)').matches && scrollStart < distance) {
                $('#Navigation').css('position','fixed');
                $('#Navigation').css('top','0px');
                $('#mainBlock').css('margin-left','85px');
            } else {
                $('#Navigation').css('position','relative');
                $('#Navigation').css('top','');
                $('#mainBlock').css('margin-left','');
            }
        });
    },
    methods: {
        logout() {
            sessionStorage.clear();
            window.localStorage.removeItem('TodoApp');
            window.location.href = logoutUrl;
        },
        onlink(link) {
            window.location.href = link;
        },
        componentSidebarChangeLayout() {
            const path = location.pathname;
            switch (path) {
                case "/":
                case "/Home":
                    var sidemenu = $("#Navigation .container ul li #sidemenus-1");// eslint-disable-line
                    break;
                case "/home":
                    var sidemenu = $("#Navigation .container ul li #sidemenus-1");// eslint-disable-line
                    break;
                case "/live":
                    var sidemenu = $("#Navigation .container ul li #sidemenus-2");// eslint-disable-line
                    break;
                case "/history":
                    var sidemenu = $("#Navigation .container ul li #sidemenus-3");// eslint-disable-line
                    break;
                case "/clip":
                    var sidemenu = $("#Navigation .container ul li #sidemenus-4");// eslint-disable-line
                    break;
                case "/settings":
                case "/settings/basic":
                case "/settings/camera":
                case "/settings/cameradetails":
                    var sidemenu = $("#Navigation .container ul li #sidemenus-5");// eslint-disable-line
                    break;
                case "/help":
                case "/help/details_livepro_user":
                    var sidemenu = $("#Navigation .container ul li #sidemenus-6");// eslint-disable-line
                    break;
                case "/help/details_livepro_admin":
                    var sidemenu = $("#Navigation .container ul li #sidemenus-6");// eslint-disable-line
                    break;
                default:
                    break;
            }
            sidemenu.addClass("active");
            sidemenu.closest('li').addClass("active");
        },
    },
    computed: {
        //*********************************************************/
        // 権限による設定画面の表示非表示
        /**********************************************************/
        settingCamLists() {
            return this.$userRoleAuthorization('sidebar', 'settingCamLists');
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/sidebar/Sidebar.css";
</style>